import type { ICrmResponsePz } from "~/interfaces";

export const FAKE_CLIENT_DATA = { 
    "cliente_id": "600000230", 
    "Nome": "GIUSEPPE",
    "Cognome": "GARIBALDI",
    "CF": "GRBGPP60A01F205R",
    "Indirizzo": "Via Fittizia 59",
    "Prov": "MI",
    "City": "MILANO",
    "CAP": 20144,
    "Phone": "+393240015825",
    "EMail": "mario.rossi@example.com",
    "Iban": "IT*********************5547", 
    "cliente_bloccato": 0,
    "flag_creditline": 1,
    "data_scadenza_documento": new Date(2030, 0, 1).getTime(), 
    "Doc_Type": 1,
    "Doc_Data_Day": 1,
    "Doc_Data_Month": 1,
    "Doc_Data_Year": 2015,
    "Doc_Data_End_Day": 1,
    "Doc_Data_End_Month": 1,
    "Doc_Data_End_Year": 2030,
    "Doc_City": "MILANO",
    "Doc_Prov": "MI",
    "Doc_Number": "AA1234567", 
    "dt_end_pz": new Date(Date.now() + (30 * 86400000)).getTime(), // CHIAVE ICrmResponsePz
    "cittadinanza": "ITA",
} as ICrmResponsePz;